import FetchUtils from '../utils/fetch.utils';
import FeatureFlags from '../utils/feature-flags.utils';
import NavigationUtils from '../utils/navigation.utils';

export default class ContactsService {
  static BASE_URL = `${process.env.PREACT_APP_API_DOMAIN_CONTACTS}/api/users`;

  static getCaaSContacts(phones) {
    if (FeatureFlags.isP2PRestrictedToSameOrganization()) {
      return FetchUtils.post(`${ContactsService.BASE_URL}/contacts`, {
        phones,
        organizationCode: NavigationUtils.getOrganizationCode(),
      });
    }

    return FetchUtils.post(`${ContactsService.BASE_URL}/contacts`, {
      phones,
    });
  }

  static getCaaSContact(phone) {
    return FetchUtils.get(`${ContactsService.BASE_URL}/contact/${phone}`);
  }

  static getCards(userId) {
    return FetchUtils.get(`${ContactsService.BASE_URL}/${userId}/cards`);
  }
}
